module.exports = __webpack_public_path__ + "bb75667feea1aabc6af0d6960ca3e222.svg";